export const loadStateSearchParam = 'loadState';
export const loadingLoadStateSearchParamValue = 'loading';

export const isForcedLoadingSearchParams = (searchParams: URLSearchParams): boolean =>
  searchParams.get(loadStateSearchParam) === loadingLoadStateSearchParamValue;

export const isForcedLoadingSearch = (search: string): boolean => {
  const normalisedSearch = search.startsWith('?') ? search.slice(1) : search;
  return isForcedLoadingSearchParams(new URLSearchParams(normalisedSearch));
};

export const useForcedLoadingState = (): boolean => {
  if (typeof window === 'undefined') return false;
  return isForcedLoadingSearch(window.location.search);
};
